import { render, staticRenderFns } from "./BookResultCard.vue?vue&type=template&id=f894d27a&"
import script from "./BookResultCard.vue?vue&type=script&lang=js&"
export * from "./BookResultCard.vue?vue&type=script&lang=js&"
import style0 from "./BookResultCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports